// @flow
import React from "react";

import Selector from '../index';
import type { Props } from '../index'
import { useGenre_Contacts } from 'redux/hooks'


export default ({ value, onChange, ...props }: Props) => {

    const data = useGenre_Contacts();

    return (
        <Selector
            {...props}
            label="Sélection des genres"
            value={value}
            onChange={onChange}
            data={data}
        />
    )
};